<template>
  <v-list-item>
    <v-list-item-icon>
      <v-icon>mdi-email</v-icon>
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-title>メールアドレス変更</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'EmailListItem'
}
</script>
